import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
const Softland = _ref => {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.545 7.065 1.88-1.885c-1.581-1.817-4.393-2.762-7.09-1.793a6.577 6.577 0 0 0-4.332 6.387c.08 2.79 2.018 5.283 4.723 6.066 2.654.769 5.283-.254 6.672-1.902l-1.857-1.885c-1.613 1.9-4.336 1.665-5.747.21-1.378-1.423-1.49-3.648-.219-5.177C6.208 6.326 7.02 5.853 8 5.72c1.423-.191 2.597.303 3.545 1.345Zm-1.89 3.014 1.856 1.885c1.617-1.879 4.319-1.739 5.8-.18a3.885 3.885 0 0 1 .058 5.27c-1.533 1.689-4.334 1.738-5.844-.096l-1.868 1.871c1.332 1.598 4.012 2.725 6.756 1.885 2.81-.86 4.685-3.452 4.646-6.418-.039-2.84-2.034-5.397-4.826-6.165-2.663-.733-5.27.356-6.578 1.948Z",
    fill: color
  }));
};
export default Softland;